import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {UserSubscription} from "../../../user/user-subscription";
import {User} from "../../../user/user";
import {CompanyInfo} from "../../../store/actions";
import {getCurrencySymbol, isCurrencySymbol} from "../../../shared/utils/currency-symbols";

@Component({
    selector: 'db-subscription-info',
    templateUrl: './subscription-info.component.html',
    styleUrls: ['./subscription-info.component.scss'],
    standalone: false
})
export class SubscriptionInfoComponent implements OnInit, OnChanges {
    @Input() companyInfo: CompanyInfo;
    @Input() subscription: UserSubscription;
    @Input() user: User;
    @Input() renew: boolean;
    @Input() showPeriodToggle: boolean = false;
    @Input() selectedPeriod: 'monthly' | 'yearly' = 'monthly';
    @Input() monthlyPlan: UserSubscription;
    @Input() yearlyPlan: UserSubscription;
    @Input() onPeriodChange: (period: 'monthly' | 'yearly') => void;
    currencySymbol: string = '$';
    isCurrencyBeforeAmount: boolean = true;
    isMobile: boolean = false;
    planInfo: any = [];

    constructor() {
    }

    ngOnInit() {
        this._updateCurrencySymbol();
        this.isMobile = window.innerWidth < 991;
        this._planInfo();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes && changes['subscription']) {
            this._planInfo();
        }
        if (changes && changes['companyInfo']) {
            this._updateCurrencySymbol();
        }
    }

    public changePlan(period: 'monthly' | 'yearly'): void {
        if (this.onPeriodChange) {
            this.onPeriodChange(period);
        }
    }

    private _planInfo() {
        const domainsCountUpgrade: number = this.subscription?.plan?.services?.hosting?.domain_count?.parameter_value;
        const domainsCount: number = this.user && this.user.hosting_services && (parseInt(this.user.hosting_services.domain_count.parameter_value, 10) + this.user.additionalWebsiteCount);
        const websitesCount = !!this.renew && domainsCount ? domainsCount : domainsCountUpgrade;

        this.planInfo = [
            { feature: (websitesCount + (websitesCount > 1 ? ' websites' : ' website'))},
            { feature: 'Full Frontend Optimization'},
            { subFeature: 'Improve Core Web Vitals'},
            { subFeature: '90+ PageSpeed score'},
            { subFeature: 'Caching'},
            { subFeature: 'Auto-optimization of unlimited pages & images'},
            { feature: 'Cloudflare Enterprise CDN'},
        ];
    }
    private _updateCurrencySymbol(): void {
        this.currencySymbol = getCurrencySymbol(this.companyInfo?.agency?.currency);
        this.isCurrencyBeforeAmount = isCurrencySymbol(this.currencySymbol);
    }
}





